import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import userLogReadAction from './userLogRead.action.json' with { type: 'json' }

const userLogReadDefinition = defineReadAutoAction(userLogReadAction, 'userLog')

export default userLogReadDefinition
